import { useMediaQuery, useTheme } from '@mui/material';
import { LG_BREAKPOINT } from '@utils/const';

export const useResponsive = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(LG_BREAKPOINT));

  const isUnder320px = useMediaQuery(theme.breakpoints.down(320));

  return { isMobile, isUnder320px };
};
